export default "__VITE_ASSET__ab27a49f__"